export default __webpack_public_path__ + "static/media/phone_in_hand_new.9a29b8f4.png";